export const ar = {
  brand: "OrderHub",
  buttons: {
    save: "حفظ",
    saving: "جارٍ الحفظ...",
    cancel: "إلغاء",
    reload: "إعادة تحميل الصفحة",
    delete: "حذف",
    retry: "إعادة المحاولة",
    close: "إغلاق",
    create: "إنشاء",
    sending: "جارٍ الإرسال...",
    edit: "تعديل",
    reset: "إعادة تعيين",
  },
  formLabels: {
    email: "البريد الإلكتروني",
    role: "الدور",
    team: "الفريق",
    status: "الحالة",
  },
  errors: {
    unexpected: "حدث خطأ غير متوقع. تم إبلاغ فريقنا.",
    somethingWentWrong: "حدث خطأ ما",
    unexpectedShort: "حدث خطأ غير متوقع. حاول مرة أخرى.",
    unknownError: "خطأ غير معروف",
  },
  empty: {
    noResults: "لا توجد نتائج",
  },
  divider: {
    or: "أو",
  },
  filter: {
    all: "الكل",
  },
  status: {
    enabled: "مُفعَّل",
    disabled: "مُعطَّل",
    loading: "جارٍ التحميل...",
  },
  select: {
    placeholder: "اختر {{label}}",
    loading: "جارٍ تحميل {{label}}...",
  },
  priority: {
    high: "عالية",
    medium: "متوسطة",
    low: "منخفضة",
  },
  pagination: {
    ariaLabel: "ترقيم الصفحات",
    previous: "السابق",
    next: "التالي",
    ariaPrevious: "الذهاب إلى الصفحة السابقة",
    ariaNext: "الذهاب إلى الصفحة التالية",
    srMorePages: "المزيد من الصفحات",
    showing: "عرض",
    of: "من",
  },
  dialog: {
    srClose: "إغلاق",
  },
  search: {
    placeholderWithCustomers: "ابحث بمرجع الطلب او اسم العميل",
    placeholderDefault: "ابحث بمرجع الطلب",
    clear: "مسح",
    typeAtLeast2: "اكتب حرفين على الأقل",
    noResults: "لم يتم العثور على نتائج",
    groupCustomers: "العملاء",
    groupActivities: "المهام",
  },
  copyToClipboard: "نسخ إلى الحافظة",
  copied: "تم النسخ!",
  help: {
    needHelpPrefix: "تحتاج مساعدة؟ ",
    contactSupport: "اتصل بالدعم",
  },
  upgrade: {
    upgradeToPlan: "الترقية إلى {{planName}}",
  },
} as const;
